/**
 * The fields of a plugin window: their starting values, read from the content the plugin
 * answered. A button sends every field's current value with its action.
 */
import type { UiNode } from "@protocol/UiNode";

/** Every field's value in `node`, by name (a checkbox gives `"true"` or `"false"`). */
export function fieldValues(node: UiNode): Record<string, string> {
  const values: Record<string, string> = {};
  /** Adds the fields in `n` and its children. */
  const walk = (n: UiNode) => {
    switch (n.type) {
      case "input":
      case "select":
        values[n.name] = n.value;
        break;
      case "checkbox":
        values[n.name] = String(n.checked);
        break;
      case "column":
      case "row":
        n.children.forEach(walk);
        break;
      case "list":
        n.items.forEach(walk);
        break;
      case "table":
        n.rows.forEach((row) => row.forEach(walk));
        break;
    }
  };
  walk(node);
  return values;
}
